// src/pages/HomePage.jsx
import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import PublicHeader from "../../Layout/PublicHeader";
import Footer from "../../Layout/VerticalLayout/Footer";
import PokemonReveal from "../../components/PokemonReveal/PokemonReveal";
import "./HomePage.css";

export default function HomePage() {
  const [timeLeft, setTimeLeft] = useState({ D: 0, H: 0, M: 0, S: 0 });

  useEffect(() => {
    const target = new Date("2025-11-01T14:00:00Z").getTime();
    const update = () => {
      const now = Date.now();
      const diff = Math.max(0, target - now);
      setTimeLeft({
        D: Math.floor(diff / 86400000),
        H: Math.floor((diff % 86400000) / 3600000),
        M: Math.floor((diff % 3600000) / 60000),
        S: Math.floor((diff % 60000) / 1000),
      });
    };
    update();
    const iv = setInterval(update, 1000);
    return () => clearInterval(iv);
  }, []);

  return (
    <>
      <PublicHeader />

      {/* Hero */}
      <section className="hero-section text-center text-white">
        <Container className="hero-inner py-5">
          <h1 className="hero-title mb-2">Pokémon Radiance</h1>
          {/* <p className="hero-subtitle mb-4">Halloween Portals Ends In</p>

          <div className="countdown d-flex justify-content-center mb-4">
            {["D","H","M","S"].map((unit) => (
              <div key={unit} className="time-block mx-2">
                <div className="time-number">{timeLeft[unit]}</div>
                <div className="time-label">
                  {unit === "D" ? "Days" :
                   unit === "H" ? "Hours" :
                   unit === "M" ? "Minutes" : "Seconds"}
                </div>
              </div>
            ))}
          </div> */}
{/* 
          <div className="reveal-container">
            <PokemonReveal />
          </div> */}
        </Container>
      </section>

      {/* About */}
<section className="about-section py-5">
  <div className="container-fluid text-center">
    <h2 className="section-heading mb-3">Welcome to Pokémon Radiance</h2>
    <p className="about-text mx-auto"> Experience the next-generation, player-driven Pokémon world.<br/>
      Discover unique variant Pokémon including <strong>Ruby, Emerald, Sapphire, Golden, Shadow, and Diamond</strong> types—each with their own style and rarity.<br/>
      Join our economy-focused adventure where live events, limited-time promos, and every major decision is shaped by the community.
    </p>

    {/* New centered button below */}
    <div className="discord-cta">
      <a
        href="https://discord.gg/mE9jv3xeP9"
        target="_blank"
        rel="noopener"
        className="btn btn-danger btn-lg"
      >
        Join our Discord
      </a>
    </div>
  </div>
</section>


      <Footer />
    </>
  );
}
